import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark mt-5 pt-3">

           
              <center><h3 className="text-light p-3">CopyRight &copy; cars dekhoo 2021</h3></center>
        

        </footer>
    );
};

export default Footer;